// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","819":"BusinessProVisitorLazyComponent"}[chunkId] + "." + {"46":"bcfa3871b07f9445876f","819":"3f5359ac5d0662cdcb63"}[chunkId] + ".js";
};